import React, { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { audioMessages } from './i18n';
import { styled } from '@mui/material/styles';
import classNames from 'classnames';

export const Recording = styled(
	({ className }: { className?: string }) => {
		const intl = useIntl();
		const [duration, setDuration] = useState(0);
		const timeoutc = useRef<number>(undefined);
		useEffect(() => {
			timeoutc.current = window.setTimeout(
				() => setDuration(duration + 1),
				1000,
			);
		}, [duration]);
		useEffect(() => () => window.clearTimeout(timeoutc.current), []);

		const seconds = duration % 60;
		const minutes = Math.floor(duration / 60);

		return (
			<div className={classNames(className, 'preview__recordings')}>
				{intl.formatMessage(audioMessages.recording_audio, {
					minutes: minutes,
					seconds: seconds < 10 ? `0${seconds}` : seconds,
				})}
			</div>
		);
	},
	{ label: 'Recording', target: 'Recording-root' },
)({
	color: 'var(--chat__footer__form__recording-audio_color)',
	fontWeight: 'bold',
});
